import { Route } from '@angular/router';
import { DC_ROUTING } from 'src/app/shared/routing.tokens';

import { aroundTheClockStatisticsRoutes } from './around-the-clock/around-the-clock.routes';
import { bobs27StatisticsRoutes } from './bobs-27/bobs-27.routes';
import { checkout121StatisticsRoutes } from './checkout-121/checkout-121.routes';
import { cricketTacticsStatisticsRoutes } from './cricket-tactics/cricket-tactics.routes';
import { doublesTrainingStatisticsRoutes } from './doubles-training/doubles-training.routes';
import { halfItStatisticsRoutes } from './half-it/half-it.routes';
import { killerStatisticsRoutes } from './killer/killer.routes';
import { matchStatisticsRoutes } from './match/match.routes';
import { randomCheckoutStatisticsRoutes } from './random-checkout/random-checkout.routes';
import { rankedGamesStatisticsRoutes } from './ranking/games/ranked-games.routes';
import { scoreTrainingStatisticsRoutes } from './score-training/score-training.routes';
import { shanghaiStatisticsRoutes } from './shanghai/shanghai.routes';
import { singlesTrainingStatisticsRoutes } from './singles-training/singles-training.routes';

export const statisticsRoutes: Route[] = [
    {
        path: DC_ROUTING.STATISTICS,
        data: {
            hideTournamentNotification: true,
        },
        loadComponent: () =>
            import('./pages/statistics-wrapper/statistics-wrapper.component').then((c) => c.StatisticsWrapperComponent),
        children: [
            {
                path: '',
                data: {
                    hideTournamentNotification: true,
                },
                loadComponent: () =>
                    import('./pages/statistics/statistics.component').then((c) => c.StatisticsComponent),
                children: [
                    {
                        path: '',
                        pathMatch: 'full',
                        redirectTo: 'match',
                    },
                    {
                        path: 'match',
                        data: {
                            hideTournamentNotification: true,
                        },
                        loadComponent: () =>
                            import('./match/pages/match-statistics/match-statistics.component').then(
                                (c) => c.MatchStatisticsComponent
                            ),
                    },
                    {
                        path: 'around-the-clock',
                        data: {
                            hideTournamentNotification: true,
                        },
                        loadComponent: () =>
                            import('./around-the-clock/pages/around-the-clock-statistics/around-the-clock-statistics.component').then(
                                (c) => c.AroundTheClockStatisticsComponent
                            ),
                    },
                    {
                        path: 'bobs-27',
                        data: {
                            hideTournamentNotification: true,
                        },
                        loadComponent: () =>
                            import('./bobs-27/pages/bobs-27-statistics/bobs-27-statistics.component').then(
                                (c) => c.Bobs27StatisticsComponent
                            ),
                    },
                    {
                        path: 'checkout-121',
                        data: {
                            hideTournamentNotification: true,
                        },
                        loadComponent: () =>
                            import('./checkout-121/pages/checkout-121-statistics/checkout-121-statistics.component').then(
                                (c) => c.Checkout121StatisticsComponent
                            ),
                    },
                    {
                        path: 'cricket-tactics',
                        data: {
                            hideTournamentNotification: true,
                        },
                        loadComponent: () =>
                            import('./cricket-tactics/pages/cricket-tactics-statistics/cricket-tactics-statistics.component').then(
                                (c) => c.CricketTacticsStatisticsComponent
                            ),
                    },
                    {
                        path: 'doubles-training',
                        data: {
                            hideTournamentNotification: true,
                        },
                        loadComponent: () =>
                            import('./doubles-training/pages/doubles-training-statistics/doubles-training-statistics.component').then(
                                (c) => c.DoublesTrainingStatisticsComponent
                            ),
                    },
                    {
                        path: 'halve-it',
                        data: {
                            hideTournamentNotification: true,
                        },
                        loadComponent: () =>
                            import('./half-it/pages/half-it-statistics/half-it-statistics.component').then(
                                (c) => c.HalfItStatisticsComponent
                            ),
                    },
                    {
                        path: 'killer',
                        data: {
                            hideTournamentNotification: true,
                        },
                        loadComponent: () =>
                            import('./killer/pages/killer-statistics/killer-statistics.component').then(
                                (c) => c.KillerStatisticsComponent
                            ),
                    },
                    {
                        path: 'random-checkout',
                        data: {
                            hideTournamentNotification: true,
                        },
                        loadComponent: () =>
                            import('./random-checkout/pages/random-checkout-statistics/random-checkout-statistics.component').then(
                                (c) => c.RandomCheckoutStatisticsComponent
                            ),
                    },
                    {
                        path: 'score-training',
                        data: {
                            hideTournamentNotification: true,
                        },
                        loadComponent: () =>
                            import('./score-training/pages/score-training-statistics/score-training-statistics.component').then(
                                (c) => c.ScoreTrainingStatisticsComponent
                            ),
                    },
                    {
                        path: 'shanghai',
                        data: {
                            hideTournamentNotification: true,
                        },
                        loadComponent: () =>
                            import('./shanghai/pages/shanghai-statistics/shanghai-statistics.component').then(
                                (c) => c.ShanghaiStatisticsComponent
                            ),
                    },
                    {
                        path: 'singles-training',
                        data: {
                            hideTournamentNotification: true,
                        },
                        loadComponent: () =>
                            import('./singles-training/pages/singles-training-statistics/singles-training-statistics.component').then(
                                (c) => c.SinglesTrainingStatisticsComponent
                            ),
                    },
                    {
                        path: 'tournament',
                        data: {
                            hideTournamentNotification: true,
                        },
                        children: [
                            {
                                path: 'match',
                                data: {
                                    hideTournamentNotification: true,
                                },
                                loadComponent: () =>
                                    import('./match/pages/tournament-match-statistics/tournament-match-statistics.component').then(
                                        (c) => c.TournamentMatchStatisticsComponent
                                    ),
                            },
                        ],
                    },
                    {
                        path: 'local-tournament',
                        data: {
                            hideTournamentNotification: true,
                        },
                        children: [
                            {
                                path: 'match',
                                data: {
                                    hideTournamentNotification: true,
                                },
                                loadComponent: () =>
                                    import('./match/pages/local-tournament/local-tournament-match-statistics/local-tournament-match-statistics.component').then(
                                        (c) => c.LocalTournamentMatchStatisticsComponent
                                    ),
                            },
                        ],
                    },
                    ...rankedGamesStatisticsRoutes,
                ],
            },
            ...matchStatisticsRoutes,
            ...randomCheckoutStatisticsRoutes,
            ...aroundTheClockStatisticsRoutes,
            ...bobs27StatisticsRoutes,
            ...checkout121StatisticsRoutes,
            ...cricketTacticsStatisticsRoutes,
            ...doublesTrainingStatisticsRoutes,
            ...halfItStatisticsRoutes,
            ...killerStatisticsRoutes,
            ...scoreTrainingStatisticsRoutes,
            ...shanghaiStatisticsRoutes,
            ...singlesTrainingStatisticsRoutes,
        ],
    },
];
